export default __webpack_public_path__ + "static/media/alien-pods-3.525dede8.jpg";